import { Select } from "@/components/atoms/Select/Select";
import { useFormContext, useController } from "react-hook-form";
import { FormSelectProps } from "./FormSelect.types";
import { cn } from "@/utils/cn";

export const FormSelect: React.FC<FormSelectProps> = ({
    name,
    control,
    options,
    label,
    placeholder = "Seleccionar",
    className,
    onChange,
    resetFields,
}) => {
    const { setValue } = useFormContext();

    const {
        field,
        fieldState: { error },
    } = useController({ name, control });

    return (
        <div className="w-full">
            {label && <label className="mb-1 text-sm font-medium">{label}</label>}
            <Select
                placeholder={placeholder}
                value={field.value ?? ""}
                onChange={(value) => {
                    field.onChange(value);
                    onChange && onChange(value);
                    resetFields?.forEach((resetField) => setValue(resetField, ""));
                }}
                options={options}
                className={cn(
                    className,
                    error && "border-red-500 focus:ring-red-500"
                )}
            />
            {error && (
                <p className="text-red-600 text-sm mt-1" role="alert">
                    {error.message}
                </p>
            )}
        </div>
    );
};
